module.exports = __webpack_public_path__ + "img/wx-default.dea12c47.png";